import paths from "~/constants/paths";

export default defineNuxtRouteMiddleware((to) => {
  const { $device } = useNuxtApp();

  if ($device.isDesktop) {
    return navigateTo(paths.account.details);
  }
});
